var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('snackbar',{ref:"snackbar"}),_c('confirm-dialog',{ref:"confirmDialog"}),_c('router-view',{attrs:{"id":"view"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }